<template>
  <a-row>
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1 faq-content">
      <a-tabs
        :active-key="$route.query.tab || 'content'"
        class="main-tabs"
        type="card"
        @change="$router.push({ query: { tab: arguments[0] } })"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>

          <!-- lang tabs -->
          <!-- <a-row
            align="middle"
            class="form_title sm-mb"
          >
            <a-col :span="4" class="form_title"> Язык: </a-col>
            <a-col :span="12">
              lang translit tabs
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
                <a-button v-if="langTab === 'oz'" @click.stop="translitAction">
                  Перевести копию на
                  {{ langTab === "uz" ? "кирилицу" : "латиницу" }}
                </a-button>
              </a-row>
            </a-col>
          </a-row> -->

          <!-- title -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> F.I.O: </a-col>
            <a-col :span="12" class="sm-mb">
              <!-- <a-input
                v-model.number="form.title[langTab]"
                placeholder="Введите название"
                spellcheck="false"
                class="form_title-input"
              />
              <div v-if="!form.title[langTab]" class="error-text">
                Заполните поле
              </div> -->
              {{ form.applicant_person }}
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Tel: </a-col>
            <a-col :span="12" class="sm-mb">
              <!-- <a-input
                v-model.number="form.title[langTab]"
                placeholder="Введите название"
                spellcheck="false"
                class="form_title-input"
              />
              <div v-if="!form.title[langTab]" class="error-text">
                Заполните поле
              </div> -->
              {{ form.phone }}
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Email: </a-col>
            <a-col :span="12" class="sm-mb">
              {{ form.email }}
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Address: </a-col>
            <a-col :span="12" class="sm-mb">
              {{ form.address }}
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Appeal type: </a-col>
            <a-col :span="12" class="sm-mb">
              {{ form.appeal_type }}
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Person type: </a-col>
            <a-col :span="12" class="sm-mb">
              {{ applicant_type[form.type_person] }}
            </a-col>
          </a-row>

          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Description: </a-col>
            <a-col :span="12" class="sm-mb">
              {{ form.description }}
            </a-col>
          </a-row>

          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Answer: </a-col>
            <a-col :span="12" class="sm-mb">
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="modalOpen = true"
              >
                <a-icon type="message" />
                Ответить на обращение
              </a-button>
            </a-col>
          </a-row>

          <!-- <a-row>
            <a-col :span="4" class="form_title"> Статус: </a-col>
            <a-switch v-model="form.is_active" />
          </a-row> -->
          <a-row :gutter="[16, 16]" class="form-buttons__action" type="flex">
            <a-col :span="6" style="text-align: right; padding-right: 8px" />
            <a-col>
              <a-button
                :disabled="pending"
                @click="$router.push('/virtual-reception/corruption')"
              >
                <a-icon type="close" />Отмена
              </a-button>
              <!--
              <a-button
                :loading="pending"
                style="margin-left: 10px"
                type="primary"
                @click="submit"
              >
                <a-icon type="check" />
                {{ form.id ? "Сохранить" : "Добавить" }}
              </a-button> -->
            </a-col>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="reply">
          <span slot="tab"> <a-icon type="project" />Ответы</span>
          <template v-if="form.replies.length">
            <a-comment v-for="(comment, index) in form.replies" :key="index">
              <template #author
                ><a>{{ comment.replier_full_name || "Admin" }}</a></template
              >
              <template #content>
                <p>
                  {{ comment.description }}
                </p>
                <a-button
                  v-if="comment.file"
                  type="link"
                  :href="comment.file"
                  target="_blank"
                  >Faylni ko'rish</a-button
                >
              </template>
              <template #datetime>
                <a-tooltip>
                  <span>{{
                    moment(comment.created_at).format("DD.MM.YYYY")
                  }}</span>
                </a-tooltip>
              </template>
            </a-comment>
          </template>
        </a-tab-pane>
      </a-tabs>
    </a-col>

    <a-modal
      :visible="modalOpen"
      title="Ответ на обращение"
      :confirm-loading="pending"
      @ok="submitReply"
      @cancel="modalOpen = false"
    >
      <a-form layout="vertical">
        <a-form-item label="Описание">
          <a-textarea
            v-model="replyText"
            rows="5"
            placeholder="Введите ответ на обращение"
          />
        </a-form-item>
        <a-form-item label="Приложить файл (необязательно)">
          <input
            ref="fileInput"
            type="file"
            accept=".pdf,.doc,.docx,.jpg,.png,.zip"
            @change="handleFileUpload"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-row>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import moment from "moment"
export default {
  data: () => ({
    modalOpen: false,
    langTab: $langPrefix,
    pending: false,
    loading: false,
    replyText: "",
    replyFile: "",
    applicant_type: {
      individual: "Jismoniy",
      juridical: "Yuridik",
      entity: "Shaxs"
    },
    form: {
      replies: [],
      title: {
        uz: "",
        oz: "",
        ru: "",
        en: "",
        qr: ""
      },
      is_active: true
    }
  }),
  computed: {
    moment() {
      return moment
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async submitReply() {
      if (!this.replyText.trim()) {
        this.$message.warning("Пожалуйста, введите текст ответа")
        return
      }

      this.pending = true
      try {
        const formData = new FormData()
        formData.append("appeal", this.form.id)
        formData.append("description", this.replyText)
        if (this.replyFile) {
          formData.append("file", this.replyFile)
        }

        const response = await this.$api.post(
          `/admin/corruption-appeal/reply/`,
          formData
        )

        if (response && (response.status === 200 || response.status === 201)) {
          this.$message.success("Ответ отправлен")
          this.modalOpen = false
          this.replyText = ""
          this.replyFile = null
          this.$refs.fileInput.value = ""

          this.$router.push({ name: "appeals" })
        }
      } catch (error) {
        console.error("Reply error", error)
        this.$message.error("Ошибка при отправке ответа")
      }

      this.pending = false
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        this.replyFile = file
      } else {
        this.replyFile = null
      }
    },
    async fetchData() {
      if (!this.$route.params.id) {
        return
      }
      this.loading = true
      try {
        const r = await this.$api.get(
          `/admin/corruption-appeal/detail/${this.$route.params.id}/`
        )
        this.form = {
          ...r.data,
          title: {
            ru: r.data && r.data.title_ru,
            en: r.data && r.data.title_en,
            oz: r.data && r.data.title_oz,
            uz: r.data && r.data.title_uz,
            qr: r.data && r.data.title_qr
          }
        }
        console.log(this.form)
      } catch (error) {
        console.error(error)
        this.loading = false
      }

      this.loading = false
    },
    // tabPaneChangeHandler(arg) {
    //   this.tabPane = arg
    // },

    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab === "uz" ? "oz" : "uz",
          methodName = this.langTab === "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }
      } catch (error) {
        console.log("translitAction error", error)
      }
    },

    async submit() {
      this.pending = true
      try {
        let newData = cloneDeep(this.form)
        newData = {
          ...newData,
          title_ru: newData.title.ru,
          title_uz: newData.title.uz,
          title_oz: newData.title.oz,
          title_en: newData.title.en,
          title_qr: newData.title.qr
        }
        delete newData.title
        let f = new FormData()

        Object.keys(newData).forEach((key) => {
          f.append(key, newData[key])
        })

        const createOrUpdate = {
          url:
            this.form && this.form.id
              ? `/admin/leadership-online-registration/notification/${this.form.id}/update/`
              : `/admin/leadership-online-registration/notification/create/`,
          method: this.form && this.form.id ? "patch" : "post",
          data: f
        }
        const r = await this.$api[createOrUpdate.method](
          createOrUpdate.url,
          createOrUpdate.data
        )
        if ((r && r.status === 200) || (r && r.status === 201)) {
          this.$message.success("Данные сохранены")
          this.$router.push({ name: "appeal" })
        }
      } catch (e) {
        console.error(e)
        this.pending = false
      }

      this.pending = false
    }
  }
}
</script>
